import { Pipe, PipeTransform } from '@angular/core';
import { countries } from '@cnet/ngx-ui';
import { enumPersonType, PersonType } from '../../../core/enums/enumPersonType';

@Pipe({
  name: 'fiscalCode',
  standalone: true,
})
export class FiscalCodePipe implements PipeTransform {

  transform(value: string, countryCode: string, personType?: PersonType): string {
    if (!value || !countryCode) return value || '';

    const country = countries.find(c => c.Code === countryCode);
    if (!country) return value;

    const mask = personType === enumPersonType.Natural 
      ? country.FiscalCodeNaturalMask 
      : country.FiscalCodeLegalMask;

    if (!mask) return value;

    return this.applyMask(value, mask);
  }

  private applyMask(value: string, mask: string): string {
    const cleanValue = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    let result = '';
    let valueIndex = 0;

    for (let i = 0; i < mask.length && valueIndex < cleanValue.length; i++) {
      const maskChar = mask[i];
      const valueChar = cleanValue[valueIndex];

      if (maskChar === '0') {
        if (/\d/.test(valueChar)) {
          result += valueChar;
          valueIndex++;
        } else {
          break;
        }
      } else if (maskChar === 'S') {
        if (/[a-zA-Z]/.test(valueChar)) {
          result += valueChar;
          valueIndex++;
        } else {
          break;
        }
      } else if (maskChar === 'A') {
        if (/[a-zA-Z0-9]/.test(valueChar)) {
          result += valueChar;
          valueIndex++;
        } else {
          break;
        }
      } else {
        result += maskChar;
      }
    }

    return result;
  }
}
